
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { formatDateTimeForInput, parseDateTimeFromInput } from '../../../../../../util';
import { CardAttribute, CardAttributeDefinition, CardAttributeDefinitionType } from '../../../../../backend/backendapi';
import forcevalid from '../../../../../../directives/forcevalid';
import VueFormAttribute from './VueFormAttribute';
import AnswersModal from '../../../../../survey/results/AnswersModal';

@Component({
  name: 'Attribute',
  components: { AnswersModal, VueFormAttribute },
  directives: {
    forcevalid,
  },
})
export default class AttributeEditor extends Vue {
  @Prop({ required: true })
  readonly definition!: CardAttributeDefinition;
  @Prop({ required: true })
  readonly attribute!: CardAttribute;

  CardAttributeDefinitionType = CardAttributeDefinitionType; //required to be used in template, vue2 

  get dateValue(): string {
    return this.attribute.value ? formatDateTimeForInput(new Date(this.attribute.value)) : '';
  }

  set dateValue(val: string) {
    this.attribute.value = !val ? '' : parseDateTimeFromInput(val).toISOString();
  }

  openSurveyResult(valueJson: string) {
    const parsedValue = JSON.parse(valueJson);
    if (parsedValue) {
      const surveyResultId = parsedValue.surveyResultId;
      const surveyId = parsedValue.surveyId;
      if (surveyId && surveyResultId) {
        (this.$refs.answerModal as AnswersModal).open(surveyId, surveyResultId);
      }
    }
  }
}
